import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  setSession(key: any, value: any): any{
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  }

  getSession(key: any): any{
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  }

  clearSession(): any{
    sessionStorage.clear();
    localStorage.clear();
  }

  getEmps(): any {
    return JSON.parse(this.getSession('myemp'));
  }

  getUser(): any {
    return JSON.parse(this.getSession('user'));
  }

  getRecruiterRoles(): any {
    return JSON.parse(this.getSession('roles'));
  }

  getManager(): any {
    return JSON.parse(this.getSession('manager'));
  }

  getRecruiters(): any {
    return JSON.parse(this.getSession('recruiters'));
  }

  getAgents(): any {
    return JSON.parse(this.getSession('agents'));
  }

  getOrderForm(): any {
    return JSON.parse(this.getSession('orderForm'));
  }

  getInterviewForm(): any {
    return JSON.parse(this.getSession('interviewForm'));
  }

  getRolePermissions(): any {
    return JSON.parse(this.getSession('roles'));
  }

  getEmpsForReportingManager(): any {
    let repEmp = this.getSession('repEmp');
    if(repEmp) {
      return JSON.parse(this.getSession('repEmp'));
    }
    return null;
  }

  copySessionToLocalStorage() {
    const sessionKeys = Object.keys(sessionStorage);

    for (const key of sessionKeys) {
      const value = sessionStorage.getItem(key);
      if (value) {
        localStorage.setItem(key, value);
      }
    }
  }
}
